<app-settings-box
  [switchCta]="!item.valueOptions"
  [selectCta]="!!item.valueOptions"
  [title]="item.title"
  [icon]="'/assets/icons/64/' + item.icon + '.svg'"
  [first]="first"
  [last]="last"
  [permission]="item.permission"
  [gallery]="gallery"
  [overridePermissionIfTrue]="item.overridePermissionIfTrue"
  [soon]="!!item.comingSoon"
  [switchValue]="!!item.value"
  [selectOptions]="item.valueOptions"
  [selectValue]="$any(item.value)"
  (onSwitch)="item.value = $event; item.onChange && item.onChange($event)"
  [small]="true"
>
  <div [innerHtml]="item.description"></div>
  <ng-content></ng-content>
</app-settings-box>
